module.exports = __webpack_public_path__ + "static/media/special-purpose-codes-icon.5df1eb1e.svg";